import { Box } from '@chakra-ui/react'
import React from 'react'

interface PageToolbarProps {
  leftElements?: React.ReactNode
  rightElements?: React.ReactNode
}

export const PageToolbar = ({ leftElements, rightElements }: PageToolbarProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        w: '100%',
        gridTemplateColumns: { base: '1fr', lg: 'auto auto' },
        alignItems: 'center',
        justifyContent: 'space-between',
        rowGap: leftElements && rightElements ? 4 : 0,
      }}
    >
      <Box sx={{ order: { base: 1, lg: 0 } }}>
        {leftElements && leftElements}
      </Box>

      <Box sx={{ order: { base: 0, lg: 1 } }}>
        {rightElements && rightElements}
      </Box>
    </Box>
  )
}
